/** 将路由 meta.permission（旧命名）映射为后端 Permission.code */
export const PERMISSION_ALIAS = {
  purchase_create: 'purchase_order',
  purchase_record: 'purchase_order',
  purchase_record_detail: 'purchase_order',
  purchase_return_create: 'purchase_return_order',
  return_record: 'purchase_return_order',
  return_record_detail: 'purchase_return_order',
  sale_create: 'sales_order',
  sale_record: 'sales_order',
  sale_record_detail: 'sales_order',
  sale_return_create: 'sales_return_order',
  sale_return_record: 'sales_return_order',
  sale_return_record_detail: 'sales_return_order',
  classification: 'goods_category',
  unit: 'goods_unit',
  information: 'goods',
  temporary_warning: 'goods',
  settlement_account: 'account',
  revenue_expenditure_items: 'charge_item',
  payment: 'payment_order',
  payment_create: 'payment_order',
  payment_detail: 'payment_order',
  collection: 'collection_order',
  collection_create: 'collection_order',
  collection_detail: 'collection_order',
  arrears_payable: 'supplier_arrears',
  arrears_payable_detail: 'supplier_arrears',
  arrears_receivable: 'client_arrears',
  arrears_receivable_detail: 'client_arrears',
  account_transfer: 'account_transfer_record',
  income_and_pay: 'charge_order',
  flow: 'finance_flow',
  flow_detail: 'finance_flow',
  sale_report: 'sales_report',
  purchase_report: 'purchase_report',
  stock_report: 'inventory',
  income_expense_statistics: 'finance_statistic',
  batch_report: 'batch',
  role: null,
  account: null,
  config: null,
}

export function resolvePermissionCode(metaPermission) {
  if (!metaPermission) return null
  if (Object.prototype.hasOwnProperty.call(PERMISSION_ALIAS, metaPermission)) {
    return PERMISSION_ALIAS[metaPermission]
  }
  return metaPermission
}

function authFromStore(storeOrAuth) {
  if (!storeOrAuth) return { isManager: false, permissions: [] }
  if (storeOrAuth.isManager != null || storeOrAuth.permissions) {
    return {
      isManager: !!storeOrAuth.isManager,
      permissions: storeOrAuth.permissions || [],
    }
  }
  const user = (storeOrAuth.state && storeOrAuth.state.user) || storeOrAuth.user || {}
  return {
    isManager: !!(user.isManager || user.is_manager),
    permissions: user.permissions || [],
  }
}

/** 是否拥有某权限码（管理员恒 true） */
export function hasPerm(code, auth) {
  const a = authFromStore(auth)
  if (a.isManager) return true
  if (!code) return true
  return (a.permissions || []).indexOf(code) !== -1
}

/** 模块删除权：需 xxx_delete（作废不受此限制） */
export function canDelete(moduleCode, auth) {
  const a = authFromStore(auth)
  if (a.isManager) return true
  return hasPerm(`${moduleCode}_delete`, a)
}

/** 产品编辑/新增 */
export function canEditGoods(auth) {
  return hasPerm('goods_edit', auth)
}

/** 查看进货价 */
export function canViewPurchasePrice(auth) {
  return hasPerm('goods_purchase_price', auth)
}

export function canAccessMenuItem(item, { isManager, permissions }) {
  if (!item) return false
  if (item.managerOnly) return !!isManager
  if (isManager) return true
  if (!item.permission) return true
  return (permissions || []).indexOf(item.permission) !== -1
}

export function filterMenus(menuList, auth) {
  return (menuList || [])
    .map((group) => ({
      ...group,
      submenus: (group.submenus || []).filter((sub) => canAccessMenuItem(sub, auth)),
    }))
    .filter((group) => (group.submenus || []).length > 0)
}

export function canAccessRoute(meta, { isManager, permissions }) {
  if (!meta) return true
  if (meta.managerOnly) return !!isManager
  if (isManager) return true
  const code = resolvePermissionCode(meta.permission)
  if (!code) {
    if (meta.permission && ['role', 'account', 'config'].includes(meta.permission)) {
      return !!isManager
    }
    return true
  }
  return (permissions || []).indexOf(code) !== -1
}
